export enum LoadingType {
  COMPONENT,
  PAGE,
}

export interface LoadingSpinner {
  type: LoadingType
}
